import { AutoComplete, Input } from 'antd';
import React, {useCallback, useState} from 'react';

const Search = ({SearchResult, onSelect, placeholder, defaultValue,value}: {SearchResult: any, onSelect: any, placeholder: string, defaultValue?: string | undefined ,value? :any }) => {
    const [options, setOptions] = useState<Array<any>>([]);
    const debounce = (func: any) => {
        let timer: any;
        return function (...args: any) {
            // const context = this;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                func(args[0])
            }, 500);
        };
    };
    const handleSearch = async (value: any) => {
        if(value) {
            let data = await SearchResult(value);
            setOptions(data);
        } else {
            setOptions([]);
        }

    };

    const optimizedFn = useCallback(debounce(handleSearch), []);
    // const onSelect = (value: any, {valId}: {valId: number | undefined}) => {
    //     findDailiesByCompany(valId)
    // };

    return (
        <AutoComplete
            popupMatchSelectWidth={252}
            style={{width: '100%',}}
            options={options}
            onSelect={onSelect}
            onSearch={optimizedFn}
            value={value}
            defaultValue={defaultValue}

        >
            <Input.Search placeholder={placeholder} enterButton />
        </AutoComplete>
    );
};

export default Search;